"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "positano": {
    "9c03a36e": [{
      "hkey": "8a28ff61",
      "slug": "positano",
      "name": "Positano",
      "primary": true,
      "skipSearch": false
    }],
    "dei-briganti-a-nord-della-rotonda": [{
      "hkey": "8a28ff61",
      "slug": "positano",
      "name": "Positano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "8b2d7585": [{
      "hkey": "8a28ff61",
      "slug": "positano",
      "name": "Positano",
      "primary": true,
      "skipSearch": false
    }],
    "la-rotonda": [{
      "hkey": "8a28ff61",
      "slug": "positano",
      "name": "Positano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;